import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRoute,
  NavigationBehaviorOptions,
  NavigationExtras,
  Params,
  Router,
} from '@angular/router';

import { AppRoutes } from './router';
import { APP_ROUTER_PATHS } from './router.provider';

@Injectable({
  providedIn: 'root',
})
export class AppRouterPaths {
  routes: AppRoutes = {} as AppRoutes;

  constructor(
    @Inject(APP_ROUTER_PATHS) private _routes: AppRoutes[],
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
  ) {
    this.routes = _routes.reduce((acc: AppRoutes, current: AppRoutes) => {
      return {
        ...current,
        ...acc,
      };
    }, {} as AppRoutes);
  }

  resolve(path: string, options?: Params): URL {
    const { query, ...params } = options || {};
    if (params) {
      path = Object.keys(params).reduce(
        (acc, param) => acc.replace(`:${param}`, params[param]),
        path,
      );
    }

    path = [window.location.origin, path]
      .map((e) => (e.startsWith('/') ? e.slice(1) : e))
      .join('/');

    // remove double slashes
    path = path.replace(/\/\//g, '/');

    const url = new URL(path);

    if (query) {
      Object.keys(query).forEach((key) => {
        url.searchParams.append(key, query[key]);
      });
    }

    return url;
  }

  navigate(url: string, params?: Params) {
    const resolved = this.resolve(url, params);

    window.location.href = resolved.toString();
  }

  navigateByUrl(
    url: string,
    options?: { relative?: boolean; native?: boolean },
  ) {
    console.log('[AppRouterPaths/navigateByUrl]', url, options);
    if (options?.relative) {
      this.relativeNavigateByUrl(url);
    }

    if (options?.native) {
      window.location.href = url;
    }
  }

  relativeNavigateByUrl(url: string) {
    // generate path name ignoring query params
    const fullUrl = new URL(window.location.href);
    const pathName = `${fullUrl.origin}${fullUrl.pathname}`;

    // generate relative path
    const path = url.replace(pathName, '');

    // navigate to relative path
    this.router.navigateByUrl(path),
      {
        relativeTo: this.activatedRoute,
      };
  }
}
